<!--新闻动态-->
<template>
  <div class="page-fixed">
    <div class="search-box">
      <form action="/">
        <form action="/">
          <search-item
            :placeholder="$t('新闻中心 | 新闻资讯')"
            @search="searchView"
            @cancel="cancelView"
            clstag="newscenter|keycount|news-H5|seatch"
          ></search-item>
        </form>
      </form>
    </div>
    <div class="seach-box" v-if="goSearch">
      <van-list
        v-model="loading[1]"
        :finished="finished[1]"
        :loading-text="$t('加载中...')"
        :finished-text="finishedText[1]"
        @load="searchApiView()"
        v-if="hasSearchData"
      >
        <div class="content">
          <trends-list :data="dataList[1]"></trends-list>
        </div>
      </van-list>
      <van-empty
        v-else
        class="custom-image img-list-box"
        :image="require('@/assets/img-m/no-list.png')"
        :description="$t('暂无数据')"
      />
    </div>
    <div class="list-box" v-else>
      <van-list
        v-model="loading[0]"
        :finished="finished[0]"
        :loading-text="$t('加载中...')"
        :finished-text="finishedText[0]"
        @load="onLoad()"
        v-if="hasPageData"
      >
        <div class="content">
          <trends-list :data="dataList[0]"></trends-list>
        </div>
      </van-list>
      <van-empty
        v-else
        class="custom-image img-list-box"
        :image="require('@/assets/img-m/no-list.png')"
        :description="$t('暂无数据')"
      />
    </div>
  </div>
</template>

<script>
import { getLang } from '@/utils'
import getTranslation from '@/locale/getTranslation'
import trendsList from '../components/trendsList'
import searchItem from '../components/searchItem' //注册搜索组件
import { getListApi, searchApi } from '@/api/news'
export default {
  components: { trendsList, searchItem },
  data() {
    return {
      //数组 0-列表 1-搜索结果
      language: getLang(),
      hasPageData: true,
      hasSearchData: true,
      dataList: [[], []],
      //搜索
      goSearch: false,
      searchValue: '',
      cancelShow: false,
      //加载
      pageNum: [1, 1],
      loading: [false, false],
      finished: [false, false],
      finishedText: ['', '']
    }
  },
  methods: {
    async onLoad() {
      const code = this.$route.query.code
      let pageNum = this.pageNum[0]
      const res = await getListApi({
        cls: code,
        pageNum,
        pageSize: '10'
      })
      if (res && res.result) {
        let { infos, total, pages } = res.result
        if (total == 0) {
          //判断暂无数据
          this.hasPageData = false
        } else {
          this.$set(this.dataList, 0, this.dataList[0].concat(infos))
          this.$set(this.loading, 0, false)
          this.$set(this.pageNum, 0, (pageNum += 1))
          if (this.pageNum[0] > pages) {
            this.$set(this.finished, 0, true)
          }
          if (total <= 10) {
            this.$set(this.finishedText, 0, '')
          } else {
            this.$set(this.finishedText, 0, getTranslation('已经到底了~'))
          }
        }
      } else {
        this.loading = false
        this.hasPageData = false
      }
    },
    async searchApiView() {
      let pageNum = this.pageNum[1]
      const options = {
        query: this.searchValue,
        filter: `cateId:portal`,
        pageNum,
        pageSize: 10
      }
      const res = await searchApi(options)
      if (res && res.result && res.result.data) {
        let { resultdata, resultcount, pageCount } = res.result.data
        if (resultcount == 0) {
          this.hasSearchData = false
        } else {
          this.$set(this.dataList, 1, this.dataList[1].concat(resultdata))
          this.$set(this.loading, 1, false)
          this.$set(this.pageNum, 1, (pageNum += 1))
          if (this.pageNum[1] > pageCount) {
            this.$set(this.finished, 1, true)
            const finishedText = `—  ${getTranslation(
              '共'
            )}${resultcount} ${getTranslation('条结果')}  —`
            this.$set(this.finishedText, 1, finishedText)
          }
        }
      } else {
        this.loading = false
        this.hasSearchData = false
      }
    },
    searchView(val) {
      console.log(val)
      this.searchValue = val
      this.goSearch = true
      this.clearSearchData()
    },
    cancelView() {
      this.goSearch = false
      this.clearSearchData()
    },
    //清空搜索数据
    clearSearchData() {
      this.$set(this.pageNum, 1, 1)
      this.$set(this.dataList, 1, [])
      this.$set(this.loading, 1, false)
      this.$set(this.finished, 1, false)
      this.$set(this.finishedText, 1, '')
      this.hasSearchData = false
      setTimeout(() => {
        this.hasSearchData = true
      })
    }
  },
  activated() {
    try {
      let options = {
        source: '新闻中心-首页',
        isShow: false
      }
      window.bridge.onShowShareButton(JSON.stringify(options))
    } catch (error) {
      console.log('APP隐藏分享按钮监听失败')
    }
  },
  beforeRouteLeave(to, from, next) {
    if (to.name == 'mobile_detail') {
      from.meta.keepAlive = true
    } else {
      from.meta.keepAlive = false
    }
    next()
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/common.scss';
/deep/.van-search {
  padding: 0.3rem 0.3rem 0;
  .van-search__content {
    background: #f7f7f7;
  }
  .van-search__action {
    color: #333;
  }
}
.content {
  padding: 0 0.3rem;
}
</style>
